export const DEFAULT_CURRENCIES = [
  { code: "TRY", symbol: "₺", name: "Türk Lirası" },
  { code: "SAR", symbol: "﷼", name: "Suudi Riyali" },
  { code: "USD", symbol: "$", name: "Amerikan Doları" },
  { code: "EUR", symbol: "€", name: "Euro" },
];

export function formatMoney(amount, code, currencies = DEFAULT_CURRENCIES) {
  const c = currencies.find((x) => x.code === code);
  const sym = c?.symbol || code || "";
  const n = new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount || 0);
  return `${sym}\u00A0${n}`;
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Intl.DateTimeFormat("tr-TR", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function daysUntil(iso) {
  const diff = new Date(iso).getTime() - Date.now();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
